jQuery(document).ready(function($) {
    const accordionGroup = 'product-accordions';
    
    $(document).on('click', `.accordion-item[data-accordion="${accordionGroup}"] .accordion-toggle`, function() {
        const clickedItem = $(this).closest('.accordion-item');
        const clickedIcon = $(this).find('i');
        const clickedContent = clickedItem.find('.accordion-content');
        
        $(`.accordion-item[data-accordion="${accordionGroup}"]`).not(clickedItem).each(function() {
            const otherIcon = $(this).find('.accordion-toggle i');
            const otherContent = $(this).find('.accordion-content');
            
            if (!otherContent.hasClass('hidden')) {
                otherContent.slideUp(300);
                otherIcon.removeClass('rotate-180');
                otherContent.addClass('hidden');
            }
        });
        
        clickedContent.slideToggle(300, function() {
            clickedContent.toggleClass('hidden');
        });
        clickedIcon.toggleClass('rotate-180');
    });
});